module.exports = __webpack_public_path__ + "img/vip@2x.c99d7c4d.png";